import React, { FC, memo } from 'react'
import Image from 'next/image'

import { ProductMedia } from '../../utils/types/Product'
import { CategoryMediaType, getCategoryIcon } from '../../utils/categoryIcons'
import { imageLoader, getSmallPreview } from '../../utils/images'
import FallBackCategoryImg from '../Graphics/FallBackCategoryImg'

interface CategoryIconProps {
  media?: ProductMedia[]
  categoryName: string
  size?: number
  className?: string
  alt?: string
  type?: CategoryMediaType
}

const CategoryIcon: FC<CategoryIconProps> = (props) => {
  const { media, categoryName, type, size = 45, className = '', alt } = props

  const categoryMedia = getCategoryIcon(media, type)
  const altText = alt || `${categoryName} category icon`

  if (type && !categoryMedia) {
    return null
  }

  // If no media available, show fallback
  if (!categoryMedia) {
    return (
      <div className={className}>
        <FallBackCategoryImg
          height={size.toString()}
          width={size.toString()}
        />
      </div>
    )
  }

  // Render the category icon/image
  return (
    <div className={className}>
      <Image
        loader={imageLoader}
        src={getSmallPreview(categoryMedia)}
        alt={altText}
        height={size}
        width={size}
      />
    </div>
  )
}

export default memo(CategoryIcon)
